/**
 * The theme's `.label`, rather than a hand-rolled pill.
 *
 * Simply White's own shape: 3px radius, 11px/600 text, 3px/5px padding — squarer and
 * tighter than the 10px pill this used to draw inline. Using the real class names means
 * these track the theme instead of drifting from it.
 *
 * The one thing that isn't inherited is what "success" looks like. Pages has no green
 * anywhere in its palette — its `.label-success` is the same sky blue as `.label-info` —
 * and these badges carry real status (approved / pending / rejected, on / off, pass /
 * fail), where blue-for-good next to blue-for-informational is not a distinction anyone
 * can read. `.label-success` is recolored to the MediclynkOS green in src/index.css, the
 * same override already applied to `.switch.success`.
 */
const TONE_CLASS = {
  neutral: 'label',
  good: 'label label-success',
  warn: 'label label-warning',
  bad: 'label label-danger',
} as const;

export function StatusBadge({
  label,
  tone = 'neutral',
}: {
  label: string;
  tone?: keyof typeof TONE_CLASS;
}) {
  return <span className={TONE_CLASS[tone]}>{label}</span>;
}
